import React from 'react'
import { Header } from './Header'
import { Marquee } from './Marquee'
import { AboutSection } from './AboutSection'
import { ProjectSection } from './ProjectSection'
import { ArticlesSection } from './ArticlesSection'
import { EmailSection } from './EmailSection'

export const Homepage = () => {
  return (
    <>
      <Header />
      <Marquee />
      <AboutSection />
      <ProjectSection variant="cursor" />
      <ArticlesSection />
      <EmailSection />
    </>
  )
}
